import * as C from '../constants';

export default {

  /**
   * @param commit
   * @param payload
   */
  show({ commit }, payload) {
    commit(C.SNACKBAR_SHOW, payload);
  },

  /**
   * @param commit
   */
  hide({ commit }) {
    commit(C.SNACKBAR_HIDE);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/snackbar/actions.js